import React, {useContext, useState, useCallback, useEffect} from 'react';

import OfflineContext from '~/components/Offline/OfflineContext';

export default function useOfflineMode() {
    const isOffline = useContext(OfflineContext);

    return {isOffline};
}
